export default __webpack_public_path__ + "static/media/like.8992b389.svg";